export default "__VITE_ASSET__DDGvK4Qr__"